import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { User } from 'src/app/classes/user';
import { UsersService } from 'src/app/services/users/users.service';
import { ModalController, Platform } from '@ionic/angular';
import { GlobalService } from 'src/app/services/global/global.service';
import { FcmService } from 'src/app/services/fcm/fcm.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {

  register=new User;
  mensajeError=<any>{};
  password=""
  repassword=""
  constructor(
    private platform:Platform,
    private uti:UtilsService,
    private usersService:UsersService,
    private modalController: ModalController,
    private global:GlobalService,
    private fcmService:FcmService
  ) { }

  ngOnInit() {
  }

  async registerUser(){
    this.mensajeError={};
    if(this.register.datos.name==""){
      this.mensajeError.name="Debe introducir un nombre";
      return false;
    }
    if(this.register.datos.apellido==""){
      this.mensajeError.apellido="Debe introducir un apellido";
      return false;
    }
    if(this.register.datos.celular==""){
      this.mensajeError.celular="Debe introducir un celular";
      return false;
    }
    if(this.register.datos.email==""){
      this.mensajeError.email="Debe introducir un email";
      return false;
    }

    if(this.password==""){
      this.mensajeError.password="Debe introducir una contraseña";
      return false;
    }
    if(this.password!=this.repassword){
      this.mensajeError.repassword="Las contraseñas no coinciden";
      return false;
    }
    this.register.datos.email=this.register.datos.email.trim();
    //consultar si el email pertenece a un email de user viejo
    let loading=this.uti.showLoaderControllable("Creando cuenta...");
    (await loading).present();
    this.usersService.getOldUSer(this.register.datos.email.trim()).then((res:User)=>{
      console.log(res);
      if(res){
        this.register.datos.doctas=res.datos.doctas;
        this.register.datos.wallet_pass=res.datos.wallet_pass;
        this.register.datos.address=res.datos.address;
      }
      this.usersService.registerUserAuth(this.register.datos.email.trim(), this.password.trim()).then((uid: string)=>{
          console.log(uid);
          this.register.uid=uid;
          this.usersService.registerUser(this.register).then(rta=>{
              this.usersService.loginUser(this.register.datos.email.trim(), this.password.trim()).then(resu=>{
                this.uti.presentSimpleAlert("Todo Listo!", "Tu usuario se creó con éxito.", "", "Mortal!!");
                loading.then(res=>{
                  res.dismiss();
                  this.usersService.getCurrentUser(resu.user.uid).subscribe((user:User)=>{
                    this.global.uid=user.uid;
                    this.global.role=user.datos.role;
                  });
                  if(this.platform.is("cordova")){
                    this.fcmService.getToken();
                  }
                  this.back();
                });
              }).catch(err=>{
                console.log(err);
                loading.then(res=>{
                  res.dismiss();
                  let mensaje=this.uti.traductor(err.message);
                  this.uti.presentSimpleAlert("Error!", mensaje, "", "Entiendo");
                });   
              })  
          }).catch(err=>{
            console.log(err);
            loading.then(res=>{
              res.dismiss();
              let mensaje=this.uti.traductor(err.message);
              this.uti.presentSimpleAlert("Error!", mensaje, "", "Entiendo");
            });   
          });
  
      }).catch(err=>{
              console.log(err);
              loading.then(res=>{
                res.dismiss();
                let mensaje=this.uti.traductor(err.message);
                this.uti.presentSimpleAlert("Error!", mensaje, "", "Entiendo");
              }); 
      });
    });

  }
  back(){
    this.modalController.dismiss();  
  }
}
